import CheckboxField from '../field/checkbox/CheckboxField';
import classNames from 'classnames';

const TableBodyRow = ({
  colDefs,
  row,
  onRowSelect,
  isChecked,
  onRowClick,
}: any) => {
  return (
    <div
      className={classNames('m-table__row', {
        selected: isChecked,
      })}
      role="row"
    >
      {/* @TODO: Is this still relevant? */}
      {/* <a
        className="u-overlay"
        aria-label="Go to detail page of this product"
        href="#"
      ></a> */}

      <div
        className="m-table__td m-table__td--interactable m-table__column--tiny m-table__column--pinned"
        role="cell"
      >
        <CheckboxField
          id={`row-${row.id || Math.random().toString()}`}
          label="check this row"
          hideLabel
          checked={isChecked}
          onChange={(e) => {
            if (onRowSelect) {
              onRowSelect(row, e.target.checked);
            }
          }}
        />
      </div>

      {colDefs.map((colDef: any, index: number) => {
        const cellValue = row[colDef.field || ''];

        const getStyles = () => {
          if (colDef.stickyPosition === undefined) return {};

          if (colDef.isLeftSticky) {
            return { left: `${colDef.stickyPosition}px` };
          }

          if (colDef.isRightSticky) {
            return { right: `${colDef.stickyPosition}px` };
          }

          return {};
        };

        return (
          <div
            key={index}
            className={classNames('m-table__td', {
              [`m-table__column--${colDef.columnSize}`]: colDef.columnSize,
              'm-table__column--pinned': colDef.isLeftSticky,
              'm-table__column--pinned-right': colDef.isRightSticky,
            })}
            style={getStyles()}
            role="cell"
            onClick={() => {
              if (onRowClick) {
                onRowClick(row);
              }
            }}
          >
            {colDef.cellRenderer ? (
              colDef.cellRenderer({
                rowData: row,
                colDef: colDef,
                value: cellValue,
              })
            ) : cellValue !== undefined && cellValue !== null ? (
              cellValue
            ) : (
              <span className="m-table__empty-cell">-</span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TableBodyRow;
